import './Header.css';
function Header({ showForm, setShowForm }) {
	return (
		<header className='header'>
			<img
				className='logo'
				src='../logo.jpg'
				alt='quotes logo'
			/>
			<h1 className='title'>Inspirational Quotes</h1>
			<button
				className='btn form-btn'
				onClick={() => setShowForm((show) => !show)}>
				{showForm ? 'Close' : 'Add your quote'}
			</button>
		</header>
	);
}
export default Header;
